module.exports = __webpack_public_path__ + "static/jeromeMisun629x417-9663638aeee89ed58fecfccd1316aebc.jpg";